<template>
    <div class="basic_wrap">
        <bsHeader :title="$t('user.signin')" @backurl="$router.back()"></bsHeader>
       
       <!-- 积分 -->
       <div class="mine_point">
        <div class="point_txt">{{ user.point }}</div>
        <div class="point_title">{{ $t('我的积分') }}</div>
       </div>
        <!-- 滚动消息 -->
        <div class="block_div notice" @click="$router.push('/notice')">
            <van-notice-bar background="#FFFFFF" color="#000000" left-icon="volume-o" :text="notice?.title || ''" />
        </div>


        <!-- 签到功能 -->
        <div class="sign_box">
          

            <!-- 签到按钮 -->
            <div class="sign_btn" @click="newsignin()">
                {{ $t('签到') }}
            </div>
        </div>

        <!-- 热门兑换 -->
        <div class="product_list_box">
            <div class="header_title">{{ $t('热门兑换') }}</div>
            <div class="product_list">
                <div class="item_product" v-for="(item, index) in list" :key="index"
                    @click="$router.push('/goods/detail/' + item.id)">
                    <div class="pro_info">
                        <img class="pro_logo" :src="item.img" alt="">
                        <div class="detail_box">
                            <div class="pro_title">{{ item.title }}<span class="hot_box">Hot</span></div>
                            <div class="pro_point">{{ item.point }}{{ $t('goods.point') }}<span class="ydh">{{ $t('已兑换')
                            }} {{ item.exchange_total }} {{ $t('次') }}</span></div>
                        </div>
                    </div>
                    <!-- 兑换 -->
                    <div class="duihuan_box">
                        <div class="duihuan_btn">
                            {{ $t('兑换') }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch';
import Api from "../../interface/index"
import axios from 'axios'
import bsHeader from '../../components/bsHeader.vue'
import {
    Swipe,
    SwipeItem,
    Progress,
    Dialog,
    Field,
    Popup,
    NoticeBar,
    Lazyload,
    Search
} from "vant";

Vue.use(Progress).use(Dialog).use(Field).use(Popup).use(NoticeBar).use(Lazyload).use(Search);

export default {
    name: "sign111",
    components: {
        VanSwipe: Swipe,
        VanSwipeItem: SwipeItem, bsHeader
    },
    data() {
        return {
            show_kefu: false,
            loading: false,
            notice: [],
            show_tc: false,
            tc_content: "",
            banners: [],
            items: [],
            langs: [],
            isApp: true,
            app: {
                "show": false,
                "name": "",
                "url": "",
                "logo": "",
            },
            value: '',
            tax: {
                show: false
            },
            signinStatue: false,
            list: [],

            user: {
                login: false,
                point: 0,
            },
            pointdata: [],
            days: "2",
            home_show: 0,
            showPage: false
        };
    },
    created() {
        if (window.plus) {
            plus.navigator.setStatusBarBackground('#FFFFFF');
            plus.navigator.setStatusBarStyle('dark');
        }
        this.$parent.footer('user', false);
    },
    mounted() {
        this.start();
    },
    methods: {
        newsignin() {
            var isapp = 0;
            if (window.plus) {
                isapp = 1;
            }
            Fetch('/user/info', {
                isapp: isapp
            }).then((r) => {
                this.signinStatue = r.data.signin;
                this.newIsSign();
            });
        },
        newIsSign() {
            let that = this;
            if (this.signinStatue) {
                this.$toast(this.$t('user.signined'));
                // setTimeout(function () {
                // 	that.$router.push('/goods');
                // }, 3000);
                return;
            }
            this.signinStatue = true;

            Fetch('/user/signin').then((r) => {
                this.$toast(this.$t('login.txt12') + r.data.point + this.$t('login.txt13'));
                this.start();
            });
        },
        signin() {

            var isapp = 0;
            if (window.plus) {
                isapp = 1;
            }
            Fetch('/user/info', {
                isapp: isapp
            }).then((r) => {
                this.signinStatue = r.data.signin;
                this.isSign();
            });

        },

        isSign() {
            let that = this;
            if (this.signinStatue) {
                this.$toast(this.$t('user.signined'));
                setTimeout(function () {
                    that.$router.push('/goods');
                }, 3000);
                return;
            }
            this.signinStatue = true;

            Fetch('/user/signin').then((r) => {
                this.$toast(this.$t('login.txt12') + r.data.point + this.$t('login.txt13'));
                setTimeout(function () {
                    that.$router.push('/goods');
                }, 3000);
            });
        },
        change(item) {
            if (item.type == 1) {
                return this.common.precision_basic(item.min * item.rate * item.day / 100);
            } else {
                return this.common.precision_basic(item.min * item.rate / 100);
            }
        },
        kefu_to() {
            if (this.show_kefu) {
                this.$router.push('/service');
            }
            this.show_kefu = !this.show_kefu;
        },
        jump(url) {
            if (url == '/qiandao') {
                // this.signin();
                this.$router.push('/sign');

            } else {
                if (url.indexOf('http') == 0) {
                    // console.log('http');
                    window.location.href = url;
                } else {
                    this.$router.push(url);
                }
            }

        },
        start() {
            Fetch('/index/int').then((r) => {
                block: {
                    if (r.data.popup.show == 1) {
                        var popup_show = sessionStorage.getItem("popup_show");
                        sessionStorage.setItem("popup_show", r.data.popup.num);
                        if (popup_show != null && popup_show == 1) {
                            break block;
                        }
                        this.tc_content = r.data.popup.content;
                        this.show_tc = true;
                    }
                }
                // console.log("banner",r.data.banner);
                this.banners = r.data.banner;
                // this.banners=[{img: "/index/banner1.png"},{img: "/index/banner2.png"}];
                this.notice = r.data.notice;
                this.langs = r.data.langs;
                this.items = r.data.items;
                this.tax = r.data.tax;
                this.pointdata = r.data.pointdata;
                this.loading = true;
                this.app = r.data.version;
                this.showPage = true;
                this.home_show = r.data.home_show;
                this.days = r.data.sign_total;

            });

            Fetch('/index/goods_list', {
                page: 1,
                listRows: 10000
            }).then(r => {
                this.user = r.data.user;
                var list = r.data.list;
                for (var i = 0; i < list.length; i++) {
                    this.list.push(list[i]);
                }

            });
        },

    }
};
</script>

<style lang="less" scoped>
.basic_wrap {
    // margin-bottom: 60px;
    position: relative;
}
.mine_point{
    margin-top: 50px;
    height: 120px;
    background: linear-gradient(to right, rgba(173, 216, 230, 0.5), #0000FF);
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .point_txt{
        font-size: 20px;
        color: white;
        font-weight: 600;
    }
    .point_title{
        color: white;
        font-size: 16px;
        margin-top: 20px;
    }
}
.red_top_bg {
	position: fixed;
	background: #FFFFFF;
	z-index: 10;
    padding: 0 0;

	.point_record {
		position: absolute;
		top: 13px;
		right: 55px;
		font-size: 14px;
	}

	.record {
		position: absolute;
		top: 11px;
		right: 15px;

		img {
			width: 22px;
			height: 22px;
		}
	}
}


.product_list_box {
    padding: 20px 16px;
    background-color: #FFFFFF;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;

    .header_title {
        font-size: 15px;
        color: black;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 15px;
    }

    .product_list {
        .item_product {
            display: flex;
            justify-content: space-between;
            padding: 20px 0;
            border-bottom: 1px solid rgba(185, 174, 174, 0.3);

            .pro_info {
                display: flex;
                justify-content: left;



                .pro_logo {
                    width: 80px;
                    height: 80px;
                }

                .detail_box {
                    display: flex;
                    flex-direction: column;
                    margin-left: 10px;
                    flex: 1;

                    .pro_title {
                        font-size: 14px;
                        line-height: 20px;
                        color: black;
                        font-weight: 500;

                        .hot_box {
                            padding: 1px 6px;
                            border: 1px solid red;
                            border-radius: 25px;
                            font-size: 10px;
                            color: red;
                            margin-left: 5px;

                        }
                    }

                    .pro_point {
                        font-size: 14px;
                        color: #FFA500;
                        font-weight: 500;
                        margin-top: auto;

                        .ydh {
                            font-size: 12px;
                            margin-left: 5px;
                            color: #817d78;
                        }
                    }


                }
            }

            .duihuan_box {
                min-width: 120px;
                display: flex;
                align-items: center;
                justify-content: right;

                .duihuan_btn {
                    padding: 5px 16px;
                    border-radius: 50px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: rgba(173, 216, 230, 0.5);
                    color: #0F6EFF;
                    font-size: 13px;
                    display: inline-block;
                }

            }
        }
    }
}

.sign_box {
    padding: 20px 16px;
    margin-bottom: 15px;
    background-color: #FFFFFF;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.05);

    .sign_list {
        width: 100%;
        display: flex;
        align-items: center;
        gap: 10px;
        flex-wrap: wrap;
        margin: 0 auto;

        .item_sign {
            width: calc((100% - 60px) / 7);

            .point {

                .no_sign_box {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    width: 100%;
                    padding: 10px 0;
                    background-color: rgba(0, 0, 0, 0.05);
                    border-radius: 8px;

                    .sign_point_num {
                        color: black;
                        margin-top: 10px;
                    }

                    .kefu_ico {
                        width: 22px;
                    }

                }

                .yes_sign_box {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    width: 100%;
                    padding: 10px 0;
                    background-color: rgba(173, 216, 230, 0.5);
                    border-radius: 8px;

                    .sign_point_num {
                        color: #3775F4;
                        margin-top: 10px;
                    }

                    .kefu_ico {
                        width: 22px;
                    }

                }

                .sign_num {
                    text-align: center;
                    color: #cebcbc;
                    margin-top: 15px;
                }

            }
        }
    }

    .sign_btn {
        width: 200px;
        padding: 10px 0px;
        color: #fff;
        background: #3775F4;
        border-radius: 16px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 20px;
    }

}



.swiper_container {
    // min-height: 182px;
    position: relative;
    background: #FFFFFF;
}

.swiper-container {
    width: 100%;
    margin: 80px 0 0 0;


    .van-swipe-item {
        overflow: hidden;
    }

    img {
        border-radius: 5px;
        margin-left: 3%;
        height: 100%;
        width: 94%;
    }
}


.notice {
    margin-bottom: 10px;
}

.work_box {
    padding: 10px 0 0 0;
    max-height: 160px;
    margin-bottom: 15px;

    .item {
        width: 33.33%;
        text-align: center;
        margin-bottom: 10px;

        .item_img {
            width: 100%;
            border-radius: 5px;
            overflow: hidden;

            img {
                width: 44px;
                height: 44px;
                padding: 4px;
            }
        }

        .item_title {
            width: 100%;
            line-height: 14px;
            font-size: 12px;
            color: #333333;
            text-align: center;
            transform: scale(0.85);
        }
    }
}

.currency_wrap {
    margin-bottom: 15px;

    img {
        width: 40px;
    }

    .currency_detail {
        padding: 20px 0;
    }

    .currency {
        justify-content: space-around;

        p {
            font-size: 14px;
            font-weight: bold;
        }

        .logo {
            p {
                margin-left: 5px;
            }
        }

        .price {
            color: #3CB371;
            font-weight: bold;
        }
    }
}

.popup {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    max-height: 60vh;
    padding: 26px 24px;
    overflow-y: auto;
    font-size: 14px;
    line-height: 20px;
}

.currency_tips {
    margin-bottom: 10px;
    margin-left: 3%;
    border-left: 5px solid #0F6EFF;
    padding-left: 10px;
    font-size: 14px;
    font-weight: bold;
}

.items {
    margin-bottom: 20px;

    .item {
        margin-bottom: 10px;


        .logo {
            position: relative;

            div {
                position: absolute;
                bottom: 0px;
                width: 100%;
                background: #FFFFFF;
                height: 30px;
                line-height: 30px;
                opacity: 0.8;
                font-weight: bold;
                padding: 0 10px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            img {
                width: 100%;
                border-radius: 5px;
                max-height: 260px;
            }
        }

        .detail {
            padding: 15px;
            line-height: 2;

            .detail_name {}

            .detail_num {
                font-weight: bold;
                color: #3CB371;
            }
        }

        .tax_detail {
            background: #ff0000;
            color: #fff;
            padding: 20px 10px;
            border-radius: 0 0 5px 5px;

            .color999 {
                color: #e1e1e1;
            }
        }
    }
}

#download_app {
    position: fixed;
    background: #fff;
    width: 100%;
    max-width: 750px;
    top: 0;
    height: 60px;
    z-index: 11;
    justify-content: space-between;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
    padding: 0 20px 0 0;

    .app_close {
        color: #999;
        width: 50px;
        line-height: 60px;
        height: 60px;
        text-align: center;
    }

    .app_logo {
        margin-right: 5px;

        img {
            height: 30px;
        }
    }

    .down_btn {
        padding: 0 5px;
        width: unset;
        height: 32px;
        line-height: 32px;
        font-size: 14px;
    }
}

/deep/.van-notice-bar {
    border-radius: 0 0 5px 5px;
}

.van-icon {
    color: #ed6a0c;
}
</style>
